
        var result = require("!!../../../../../node_modules/css-loader/index.js!./fraud-reports-table.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/views/admin/fraud-reports/fraud-reports-table.css
// module id = 1479
// module chunks = 0